import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { Grid } from '@material-ui/core';
import SideCard from '../StubPageSideCard';
import SimpleModal from '../Modal';
import MediaPlayer from '../MediaPlayer';
import { colors } from '../../constants/styleConstants';

const useStyles = makeStyles(() => ({
  videoBox: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  videoBtn: {
    display: 'flex',
    flexWrap: 'wrap',
    borderRadius: '2px',
    padding: 0,
    border: 0,
    margin: '0 2px 4px',
    cursor: 'pointer',
    '&:focus': {
      outline: 0,
    },
  },
  btnWrapper: {
    width: '112px',
    height: '146px',
    minWidth: '112px',
    minHeight: '146px',
    pointerEvents: 'none',
    cursor: 'pointer',
  },
  sideCard: {
    marginBottom: 20,
  },
  videoModal: {
    minHeight: '55vh',
  },
  videoView: {
    height: '445px',
    width: '100%',
  },
  rightArrow: {
    fontSize: '1.1rem',
    color: colors.blueChip,
  },
}));

const VideoCard = ({ title, videos, maxCountVideos, goToTab, tabName }) => {
  const classes = useStyles();

  const [isModalOpen, setModalOpen] = React.useState(false);
  const [chosenVideo, setVideoNumber] = React.useState(0);

  const openModal = videoNumber => {
    setVideoNumber(videoNumber);
    setModalOpen(true);
  };

  const closeModal = () => {
    setVideoNumber(0);
    setModalOpen(false);
  };

  return (
    <SideCard
      title={title}
      className={classes.sideCard}
      titleActionComponent={
        <a onClick={() => goToTab('videos')} className={classes.link}>
          <ArrowForwardIcon className={classes.rightArrow} />
        </a>
      }
      tabName={tabName}
    >
      <div className={classes.videoBox}>
        {videos.slice(0, maxCountVideos).map((video, index) => (
          <button type="button" className={classes.videoBtn} key={index} onClick={() => openModal(index)}>
            <MediaPlayer
              record={video}
              type="thumb"
              showPlayButton
              className={classes.btnWrapper}
              onThumbClick={() => null}
            />
          </button>
        ))}
        <SimpleModal isModalOpen={isModalOpen} onClose={closeModal} className={classes.videoModal} disableBackdropClick>
          <Grid container spacing={4} id="video">
            <Grid item xs={12} className={classes.videoView}>
              <MediaPlayer record={videos[chosenVideo]} playing showPlayButton={false} showControls />
            </Grid>
          </Grid>
        </SimpleModal>
      </div>
    </SideCard>
  );
};

VideoCard.propTypes = {
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
    }),
  ),
  title: PropTypes.string,
  maxCountVideos: PropTypes.number,
  tabName: PropTypes.string,
  goToTab: PropTypes.func,
};

export default VideoCard;
